import Swiper from 'swiper';
import {Navigation, Pagination, EffectCreative, Autoplay } from 'swiper/modules'
Swiper.use([Pagination, Navigation, EffectCreative, Autoplay]);

const heroSwiper = new Swiper('.hero-swiper', {
  direction: 'vertical',
  spaceBetween: 40,
  slidesPerView: 1,
  loop: true,
  autoplay: {
    delay: 4000,
    disableOnInteraction: false,
  },

  navigation: {
    nextEl: '.hero-swiper-button-next',
    prevEl: '.hero-swiper-button-prev',
  },
});
